import { render, staticRenderFns } from "./ActionMealSave.vue?vue&type=template&id=389e0290&scoped=true"
import script from "./ActionMealSave.vue?vue&type=script&lang=js"
export * from "./ActionMealSave.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389e0290",
  null
  
)

export default component.exports